import { Loading, Icon, Breakpoints } from 'JBSrc/constants';
import { sessionFlash } from 'JBSrc/session-flash';
import { scrollTo } from 'JBPlugin/scroll-to';
let checkInterval, timer = 0;

class EventPrint {
	constructor(){
		this.eventPrintClass = '.event-print';
		this.eventPrintContainer = '.event-print__main';
		this.current_navigation_sections = [];
		this.current_section = '';
		this.fields = [];
		this.id = $(this.eventPrintClass).data('id');
		this.eventType = $(this.eventPrintClass).data('type');
	}

	buildSections(){
		let self = this;
		$.get('/ajax/events/section/navigation?eventType=' + self.eventType, function(data){
			let html = [];
			html.push('<div class="event-print__sections">');
			for (let key in data) {
				if (data.hasOwnProperty(key)) {
					if(self.current_section === '' && !data[key].hasOwnProperty('children')){
						self.current_section = key;
					}

					if(data[key].hasOwnProperty('children')){
						html.push('<h2 data-parent="' + key + '">' + data[key]['title'] + '</h2>');
						html.push('<div data-parent="' + key + '">');
						for (let child_key in data[key]['children']) {
							if(self.current_section === ''){
								self.current_section = child_key;
							}
							let child = data[key]['children'][child_key];
							html.push('<div class="event-print__section" data-section="' + child_key + '">' + Loading.event_section + '</div>');
							self.getSection(child_key);
							self.current_navigation_sections.push(child_key);
						}
						html.push('</div>');
					}else{
						html.push('<div class="event-print__section" data-section="' + key + '">' + Loading.event_section + '</div>');
						self.getSection(key);
						self.current_navigation_sections.push(key);
					}

					html.push('</li>');
				}
			}
			html.push('</div>');
			$(self.eventPrintContainer).html(html.join("\n"));
		},'json');
	}

	showHideChecks(section){
		let self = this;
		const data = self.getFormData();
		let isVisible, passes, field;

		$('.event-print__section[data-section="' + section + '"] .form-group[data-field]').each(function(){
			isVisible = true;
			field = $(this).data('field');
			if($(this).data('show_when') !== undefined && $(this).data('show_when') !== ''){
				passes = self.checkFieldPasses($(this).data('show_when'));
				isVisible = passes;
			}else if($(this).data('hide_when') !== undefined &&  $(this).data('hide_when') !== ''){
				passes = self.checkFieldPasses($(this).data('hide_when'));
				isVisible = !passes;
			}

			if(isVisible){
				$(this).show();
			}else{
				$(this).hide();
			}
		});
	}

	checkFieldPasses(rule){
		let self = this;
		const data = self.getFormData();
		let passes = [];
		let ors = Object.keys(rule).filter((key) => {
			return key.startsWith('or_');
		});

		for (let field in rule) {
			if (ors.includes(field)) {
				let trimmed = field.substr(3);

				if (data[trimmed] === rule[field]) {
					return true;
				}
			}

			if (! ors.includes(field) && Array.isArray(rule[field])) {
				passes.push(rule[field].includes(data[field]));
			} else {
				if (rule[field] === 'not null') {
					passes.push(data[field] !== null);
				} else {
					passes.push(data[field] === rule[field]);
				}
			}
		}
		return !passes.includes(false);
	}

	getFormData(){
		return window.form_data;
	}

	getSection(section){
		let self = this;
		$.get('/ajax/events/print?section=' + section + '&id=' + self.id, function(data){
			$('.event-print__section[data-section="' + section + '"]').html(data);
			self.showHideChecks(section);
		});
	}

	loadingCheck(){
		let self = this;
		timer += 1;
		if($('.event-print__section .loading').length === 0){
			clearInterval(checkInterval);
			$('.eventPrintButton').removeClass('disabled').removeAttr('disabled');
			$('.event-print__type .loading, .event-print__type .timer').remove();
		}else if($('.event-print__type').find('.loading').length === 0){
			$('.event-print__type').prepend(Loading.print + ' <p class="text-center timer"></p>');
		}

		if($('.event-print__type .timer').length){
			//$('.event-print__type .timer').html(timer + ' secs');
		}
	}

	initTriggers(){
		let self = this;
		$(self.eventPrintContainer).html(Loading.request);
		self.buildSections();
		setTimeout(function(){
			checkInterval = setInterval(self.loadingCheck, 1000);
		}, 1000);
	}
}

(function($) {
	const eventPrint = new EventPrint;
	if($(eventPrint.eventPrintClass).length){
		eventPrint.initTriggers();
	}
})(jQuery);
